import { Profile } from '../types';
import { AbstractApi } from '../../abstract-api';
import { ENDPOINTS, USER_TYPES, DEFAULT_PARAMS } from '../consts';

export class UserProfileApi extends AbstractApi {
  async getUserProfile(): Promise<Profile> {
    const axios = await this.axios();
    const { data } = await axios.get<Profile>(ENDPOINTS.USER.PROFILE);
    return {
      ...data,
      department: data.department // Ensure correct format for department
        .toLocaleLowerCase()
        .replaceAll(',', '')
        .replaceAll(' ', '_')
        .replaceAll('-', '_')
        .replaceAll("'", ''),
      contractType:
        data.contractType.toLocaleLowerCase() === DEFAULT_PARAMS.CONTRACT_TYPE
          ? USER_TYPES.PROFESSIONAL_SERVICES
          : USER_TYPES.ACADEMIC,
    };
  }
}
